import { LocaleSchema } from '@upme/contracts';
import type { Locale } from '@upme/view-logic';

/** Список значений — из единственного источника (contracts). */
export const SUPPORTED_LOCALES = LocaleSchema.options as readonly Locale[];

export const LOCALE_LABELS: Record<Locale, string> = {
  ru: 'Русский',
  en: 'English',
};
